<main class="main" id="leasing-endwoment">
  <form class="content" [formGroup]="form">
    <!-- Tipo: Función -->
    <section
      class="content--item"
      *ngIf="requestType === requestTypeEnum.function"
    >
      <h5 class="content--title">
        {{ 'requestPetitionerSelectClass' | i18next }}
      </h5>
      <div class="content--class">
        <mat-form-field class="content--class__item">
          <mat-label required>{{ 'typeClass' | i18next }}</mat-label>
          <mat-select formControlName="class">
            <mat-option *ngFor="let option of options" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="form.value.class === 'Delegado sindical'">
          <div class="content--class__inputContainer">
            <input
              class="content--class__input"
              required=""
              mat-input
              type="text"
              placeholder="NIS"
              formControlName="nis"
              (change)="setDSNis()"
            />
            <div class="text-center spinner-container" [hidden]="!spinner">
              <div class="spinner-border spinner" role="status"></div>
            </div>
          </div>
          <div class="error content--class__nisError" *ngIf="nisErrorText">
            <small>{{ nisErrorText }}</small>
          </div>
        </div>
      </div>
    </section>
    <!-- Tipo: Dotación - arrendamiento -->
    <section
      class="content--item"
      *ngIf="
        requestType === requestTypeEnum.dotArr ||
        requestType === requestTypeEnum.campaigns
      "
    >
      <h5 class="content--title">{{ 'requestTypeTitle' | i18next }}</h5>
      <div class="content--info">
        <mat-radio-group
          class="content--info__radioContainer"
          color="primary"
          formControlName="type"
        >
          <mat-radio-button
            class="content--info__input"
            id="arr"
            value="LEASING"
            [checked]="form.get('type')?.value === 'LEASING'"
            [disabled]="disableArrBtn()"
            #typeArr
            (change)="vehicleType(typeArr.value)"
            >{{ 'typeArr' | i18next }}</mat-radio-button
          >
          <mat-radio-button
            class="content--info__input"
            id="dotation"
            value="ENDOWMENT"
            [disabled]="user ? user.groupType === 'EXP' : false"
            [checked]="form.get('type')?.value === 'ENDOWMENT'"
            [disabled]="disableDotBtn()"
            #typeDot
            (change)="vehicleType(typeDot.value)"
            >{{ 'typeEndowment' | i18next }}</mat-radio-button
          >

          <mat-radio-button
            *ngIf="requestType === 'ENDOWMENT_LEASING'"
            class="content--info__input"
            id="secondaryLeasing"
            value="SECONDARY_LEASING"
            [checked]="form.get('type')?.value === 'SECONDARY_LEASING'"
            #typeSecLeas
            (change)="vehicleType(typeSecLeas.value)"
            >{{ 'typeArrNoLab' | i18next }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </section>
    <!-- Subtipo: Sustición - 1º asignación -->
    <section
      class="content--item"
      *ngIf="
        requestType === requestTypeEnum.function ||
        requestType === requestTypeEnum.dotArr ||
        requestType === requestTypeEnum.campaigns ||
        requestType === requestTypeEnum.generalServices ||
        requestType === requestTypeEnum.innerRoute
      "
    >
      <h5 class="content--title">
        {{ 'requestSubtypeTitle' | i18next }}
      </h5>
      <div class="content--itemContainer">
        <div class="content--infoSubtype">
          <mat-radio-group
            class="content--infoSubtype__radioContainer"
            formControlName="subtype"
            color="primary"
          >
            <mat-radio-button
              class="content--infoSubtype__input"
              id="subtype"
              value="FIRST_ASSIGNMENT"
              [checked]="form.get('subtype')?.value === 'FIRST_ASSIGNMENT'"
              [disabled]="
                isFirstAssignNotAvailable() &&
                (requestType === requestTypeEnum.dotArr ||
                  requestType == requestTypeEnum.function)
              "
              (change)="changeSubtype('FIRST_ASSIGNMENT')"
              >{{ 'subtypeFirstAssign' | i18next }}</mat-radio-button
            >
            <mat-radio-button
              class="content--infoSubtype__input"
              id="subtype"
              [checked]="form.get('subtype')?.value === 'SUBSTITUTION'"
              [disabled]="disableSubstitution()"
              value="SUBSTITUTION"
              (change)="changeSubtype('SUBSTITUTION')"
              >{{ 'subtypeSus' | i18next }}</mat-radio-button
            >
          </mat-radio-group>
        </div>
        <div
          class="content--infoExtra"
          *ngIf="requestType !== requestTypeEnum.function"
        >
          <div
            class="content--infoExtra__retribution"
            *ngIf="
              requestType === requestTypeEnum.dotArr ||
              requestType === requestTypeEnum.campaigns
            "
          >
            <p class="content--infoExtra__retribution--title">
              {{ 'retribution' | i18next }}
            </p>
            <p class="content--infoExtra__retribution--text">
              {{ retributionText }}
            </p>
          </div>
          <div
            class="content--infoExtra__deliveryLocation"
            *ngIf="
              user?.workPlace !== DeliveryLocation.MARTORELL &&
              requestType !== requestTypeEnum.generalServices &&
              requestType !== requestTypeEnum.innerRoute
            "
          >
            <mat-checkbox
              color="primary"
              formControlName="deliveryLocationChecked"
            >
              {{ 'deliveryLocationText' | i18next }}</mat-checkbox
            >
          </div>
        </div>
      </div>
    </section>
    <!-- Tipo: Préstamos -->
    <app-loan-request-info
      *ngIf="requestType === requestTypeEnum.loan"
      [user]="user"
      (formEmitter)="updateLoanInfo($event)"
    ></app-loan-request-info>
    <!-- Tipo: Dictámenes -->
    <section
      class="content--item"
      *ngIf="requestType === requestTypeEnum.judgements"
    >
      <h5 class="content--title">
        {{ 'judgementData' | i18next }}
      </h5>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'location' | i18next }}</mat-label>
          <textarea
            matInput
            class="textarea"
            formControlName="location"
            name="location"
            rows="3"
            cols="100"
          >
          </textarea>
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'engine' | i18next }}</mat-label>
          <textarea
            matInput
            class="textarea"
            formControlName="engine"
            name="engine"
            rows="3"
            cols="100"
          >
          </textarea>
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'runningGear' | i18next }}</mat-label>
          <textarea
            matInput
            class="textarea"
            formControlName="train"
            name="train"
            rows="3"
            cols="100"
          >
          </textarea>
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'electricSystem' | i18next }}</mat-label>
          <textarea
            matInput
            class="textarea"
            formControlName="electric"
            name="electric"
            rows="3"
            cols="100"
          >
          </textarea>
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'security' | i18next }}</mat-label>
          <textarea
            matInput
            class="textarea"
            formControlName="security"
            name="security"
            rows="3"
            cols="100"
          >
          </textarea>
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'bodywork' | i18next }}</mat-label>
          <textarea
            matInput
            class="textarea"
            formControlName="bodywork"
            name="bodywork"
            rows="3"
            cols="100"
          >
          </textarea>
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'externalFinishes' | i18next }}</mat-label>
          <textarea
            matInput
            class="textarea"
            formControlName="external"
            name="external"
            rows="3"
            cols="100"
          >
          </textarea>
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'internalFinishes' | i18next }}</mat-label>
          <textarea
            matInput
            class="textarea"
            formControlName="internal"
            name="internal"
            rows="3"
            cols="100"
          >
          </textarea>
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label for="estimatedKms">{{
            'requestEstimatedKms' | i18next
          }}</mat-label>
          <input
            matInput
            type="number"
            name="estimatedKms"
            formControlName="estimatedKms"
          />
        </mat-form-field>
      </div>
      <div class="content--judgements">
        <mat-form-field>
          <mat-label>{{ 'OTHERS' | i18next }}</mat-label>
          <textarea
            matInput
            class="textarea"
            formControlName="others"
            name="others"
            rows="3"
            cols="100"
          >
          </textarea>
        </mat-form-field>
      </div>
    </section>
    <!-- Tipo reserva vehículo -->
    <section class="content--item" *ngIf="requestType === 'bookVehicle'">
      <h5 class="content--title">
        {{ 'reservationRecipient' | i18next }}
      </h5>
      <section class="content--book">
        <div class="d-flex flex-column w-100 gap-2">
          <div class="d-flex flex-column gap-1 firstSelect">
            <label for="petitionerType">{{ 'forWhom' | i18next }}*</label>
            <select
              required
              name="petitionerType"
              id="petitionerType"
              formControlName="petitionerType"
              class="primary-input"
            >
              <option [value]="petitionerTypeEnum.SEAT">
                {{ 'seatEmployee' | i18next }}
              </option>
              <option [value]="petitionerTypeEnum.EXT">
                {{ 'external' | i18next }}
              </option>
              <option [value]="petitionerTypeEnum.FAM">
                {{ 'familiar' | i18next }}
              </option>
            </select>
          </div>
          <div class="d-flex flex-column flex-md-row w-100 gap-2">
            <div class="d-flex flex-column w-100 gap-1">
              <label for="name">{{ 'name' | i18next }}*</label>
              <input
                required
                id="name"
                class="primary-input"
                formControlName="name"
                type="text"
              />
            </div>
            <div class="d-flex flex-column w-100 gap-1">
              <label for="firstSurname">{{ 'firstSurname' | i18next }}*</label>
              <input
                required
                id="firstSurname"
                class="primary-input"
                formControlName="firstSurname"
                type="text"
              />
            </div>
          </div>
          <div class="d-flex flex-column flex-md-row w-100 gap-2">
            <div class="d-flex flex-column w-100 gap-1">
              <label for="secondSurname"
                >{{ 'secondSurname' | i18next }}*</label
              >
              <input
                required
                id="secondSurname"
                class="primary-input"
                formControlName="secondSurname"
                type="text"
              />
            </div>
            <div class="d-flex flex-column w-100 gap-1">
              <label for="phone">{{ 'phone' | i18next }}*</label>
              <input
                required
                id="phone"
                class="primary-input"
                formControlName="phone"
                type="text"
                minlength="9"
                maxlength="9"
                pattern="^[0-9]*$"
              />
            </div>
          </div>
          <div class="d-flex flex-column gap-1 emailInput">
            <label for="email">{{ 'email' | i18next }}*</label>
            <input
              required
              id="email"
              class="primary-input"
              formControlName="email"
              type="email"
              pattern="[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]{2,4}$"
            />
          </div>
        </div>
      </section>
    </section>
    <app-step-projects
      *ngIf="requestType === requestTypeEnum.proyect"
      (formChange)="handleFormProjectChange($event)"
    ></app-step-projects>
  </form>
  <!-- Cesiones -->
  <section class="search" *ngIf="requestType === requestTypeEnum.transfers">
    <h5
      class="search--title"
      style="margin-top: 10px; margin-bottom: 10px; font-weight: bold"
    >
      {{ 'petitionInfo' | i18next }}
    </h5>
    <form class="additional d-flex flex-wrap" [formGroup]="form">
      <div class="additional--item me-4">
        <mat-form-field class="additional--column__item">
          <mat-label for="deliveryDateTransfers" class="additional--label">{{
            'deliveryDate' | i18next
          }}</mat-label>
          <input
            matInput
            [matDatepicker]="pickerDelivery"
            class="additional--dateInput"
            name="deliveryDate"
            formControlName="deliveryDate"
            [min]="minDate"
            (change)="changeDateTransfers('deliveryDate')"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="pickerDelivery"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #pickerDelivery
            (closed)="close('pickerDelivery')"
          ></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="additional--item col-12 col-sm-6">
        <mat-form-field class="additional--column__item">
          <mat-label for="returnDateTransfers" class="additional--label">{{
            'returnDate' | i18next
          }}</mat-label>
          <input
            matInput
            [matDatepicker]="pickerReturn"
            class="additional--dateInput"
            name="returnDate"
            formControlName="returnDate"
            (change)="changeDateTransfers('returnDate')"
            [min]="form.get('deliveryDate')!.value"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="pickerReturn"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #pickerReturn
            (closed)="close('pickerReturn')"
          ></mat-datepicker>
        </mat-form-field>
      </div>
    </form>
  </section>

  <!-- Placas rojas -->
  <section class="redPlates" *ngIf="requestType === requestTypeEnum.redPlates">
    <h5 class="redPlates--title">{{ 'petitionInfo' | i18next }}</h5>
    <form class="redPlates--form" [formGroup]="form">
      <div class="redPlates-form__date">
        <mat-form-field>
          <mat-label>{{ 'needDate' | i18next }}</mat-label>
          <input
            matInput
            [matDatepicker]="pickerNeedDate"
            formControlName="date"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="pickerNeedDate"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #pickerNeedDate
            (closed)="close('pickerNeedDate')"
          ></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="redPlates--form__inputContainer">
        <div class="redPlates--form__input">
          <mat-form-field>
            <mat-label>{{ 'platesOfNumber' | i18next }}</mat-label>
            <input
              type="number"
              matInput
              formControlName="numberPlates"
              min="1"
            />
          </mat-form-field>
        </div>
        <div class="redPlates--form__input">
          <mat-form-field>
            <mat-label>{{ 'numberOfBulletins' | i18next }}</mat-label>
            <input
              type="number"
              matInput
              formControlName="numberAddBulletins"
              min="0"
            />
          </mat-form-field>
        </div>
        <div class="redPlates--form__input">
          <mat-form-field>
            <mat-label>{{ 'numberOfTriplePlates' | i18next }}</mat-label>
            <input
              type="number"
              matInput
              formControlName="numberTriplePlates"
              min="0"
            />
          </mat-form-field>
        </div>
      </div>
    </form>
  </section>

  <!-- Tipo: Entrada/Salida -->
  <app-es-request-info
    *ngIf="requestType === requestTypeEnum.es"
    [user]="user"
    (formEmitter)="updateEsInfo($event)"
  ></app-es-request-info>

  <div class="main--btnContainer">
    <button
      [disabled]="form.invalid || (requestType === 'FUNCTION' && nisDsError)"
      class="main--btnContainer__btn btn confirm"
      matStepperNext
      mat-button
      (click)="nextStep()"
      [style]="
        form.invalid || (requestType === 'FUNCTION' && nisDsError)
          ? 'background-color: #565554'
          : 'background-color: #2c2a29'
      "
    >
      {{ 'btnContinue' | i18next | uppercase }}
    </button>
    <button
      class="main--btnContainer__btn btn cancel"
      [style]="'background-color: #2c2a29'"
      mat-button
      (click)="backStep()"
    >
      {{ 'btnReturn' | i18next | uppercase }}
    </button>
  </div>
</main>
